import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, Radar, PolarRadiusAxis } from 'recharts';
interface ScoreChartsProps {
  scores: {
    sales: number;
    marketing: number;
    operations: number;
    hr: number;
    finance: number;
  };
}
export const ScoreCharts: React.FC<ScoreChartsProps> = ({
  scores
}) => {
  const data = Object.entries(scores).map(([name, value]) => ({
    name: name.charAt(0).toUpperCase() + name.slice(1),
    value
  }));
  const getBarColor = (score: number) => {
    if (score >= 80) return '#10B981'; // green-500
    if (score >= 50) return '#F59E0B'; // yellow-500
    return '#EF4444'; // red-500
  };
  return <div className="bg-white rounded-lg border shadow-sm p-6" data-id="element-276">
      <h3 className="text-lg font-bold text-gray-800 mb-4" data-id="element-277">
        Performance Visualization
      </h3>
      <div className="h-64 mb-8" data-id="element-278">
        <ResponsiveContainer width="100%" height="100%" data-id="element-279">
          <BarChart data={data} margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }} data-id="element-280">
            <CartesianGrid strokeDasharray="3 3" data-id="element-281" />
            <XAxis dataKey="name" data-id="element-282" />
            <YAxis domain={[0, 100]} data-id="element-283" />
            <Tooltip data-id="element-284" />
            <Bar dataKey="value" name="Score" fill="#3B82F6" radius={[4, 4, 0, 0]} data-id="element-285" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="h-64" data-id="element-286">
        <ResponsiveContainer width="100%" height="100%" data-id="element-287">
          <RadarChart outerRadius={90} data={data} data-id="element-288">
            <PolarGrid data-id="element-289" />
            <PolarAngleAxis dataKey="name" data-id="element-290" />
            <PolarRadiusAxis domain={[0, 100]} data-id="element-291" />
            <Radar name="Score" dataKey="value" stroke="#3B82F6" fill="#93C5FD" fillOpacity={0.6} data-id="element-292" />
            <Tooltip data-id="element-293" />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>;
};